import { METHOD_TEMPLATES } from "../../../utils/consts";
import { requestCgi } from "../common/requestCgi";
import { get as lodashGet } from "lodash-es";
import { printLog } from "../../../../../tools/log";
function getUpsertMethod(cgiName, msg) {
  const fn = async function (params) {
    const res = await requestCgi({
      cgiName,
      params,
      instance: this,
      cgiMessage: msg
    });
    const data = lodashGet(res.body, this.protocol.ENTITY_DATA);
    if (res.success && typeof data === 'object') {
      this.formData = data;
    }
    return res.body;
  };
  fn.template = [cgiName === 'create' ? METHOD_TEMPLATES.form.create : METHOD_TEMPLATES.form.update];
  return fn;
}
export const create = getUpsertMethod('create', '新建成功');
export const update = getUpsertMethod('update', '更新成功');
export const get = async function get(params) {
  await this.promiseForCollection;
  if (this.isDB) {
    var _params$request;
    // db类型数据源判断是否有id才请求, http无法判断，因为不知道http的请求协议是什么
    const id = (_params$request = params.request) === null || _params$request === void 0 || (_params$request = _params$request.query) === null || _params$request === void 0 ? void 0 : _params$request.id;
    // 数字 0 也是合法的id
    if (id === null || id === undefined || typeof id === 'string' && !id.trim()) {
      console.log('db get接口没有传id参数，停止请求');
      return;
    }
  }
  const res = await requestCgi({
    cgiName: 'get',
    params,
    instance: this
  });
  if (res.success) {
    const data = lodashGet(res.body, this.protocol.ENTITY_DATA);
    if (data) {
      this.formData = data;
    } else {
      // message.error('get接口返回了空数据');
      printLog('get接口返回了空数据');
    }
  }
  return res.body;
};
get.template = [METHOD_TEMPLATES.form.get];
// delete 是关键字
export const deleteMethod = async function deleteMethod(params) {
  const res = await requestCgi({
    cgiName: 'delete',
    params,
    instance: this,
    cgiMessage: '删除成功'
  });
  // if (res.success) {
  //   arrayRemove(this.listData, res);
  // }
  // 删除成功直接刷新了，组件生成适配下事件
  return res.body;
};
deleteMethod.template = [METHOD_TEMPLATES.form.delete];
//# sourceMappingURL=crud.js.map
